import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useMe } from '../../../hooks/me';
import { SpcConnect } from '../../../spc/connect/SpcConnect';
import { OrderHistoryPage } from '../../order/history/OrderHistoryPage';
import { BrowsePage } from '../../browse/BrowsePage';
import { useApiQuery } from '@orderx/lab/xr/http';
import { AccountWalletPage } from '../wallet/AccountWalletPage';
import { Environment } from '../../../environment';
import { XSection, XSectionHeader, XList, useRouter } from '@orderx/lab/ui';
import { XOverlay } from '../../../components/x/overlay/XOverlay';

const Wrapper = styled.div`
    .deployed-at {
        position: absolute;
        bottom: 1px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 0.5rem;
        color: var(--x-color-text-secondary);
        font-weight: bold;
    }
`;

export function AccountIndexPage() {
    const { user, isAuthenticated, loadUser, signOut } = useMe();
    const { run, response } = useApiQuery(async () => {
        await loadUser();
        return true;
    });
    const router = useRouter();

    useEffect(() => {
        run();
    }, []);

    if (!response) {
        return <XOverlay type="loading" />;
    }

    if (!isAuthenticated) {
        return <SpcConnect onBack={() => router.goBack()} />;
    }

    return (
        <Wrapper className={'AccountPage'}>
            <XSectionHeader title={`Welcome, ${user.firstName}`} />

            <XSection>
                <XList
                    items={[
                        {
                            to: OrderHistoryPage,
                            type: 'nav',
                            icon: 'receipt_long',
                            title: 'Orders',
                        },
                        {
                            to: AccountWalletPage,
                            type: 'nav',
                            icon: 'account_balance_wallet',
                            title: 'Wallet',
                        },
                        {
                            to: BrowsePage,
                            type: 'nav',
                            icon: 'exit_to_app',
                            title: 'Sign out',
                            onClick() {
                                signOut();
                            },
                        },
                    ]}
                />
            </XSection>

            <div className="deployed-at">{Environment.APP_VERSION}</div>
        </Wrapper>
    );
}

AccountIndexPage.route = '/account';
